export const environment = {
  production: true,
  apiBaseUrl: 'https://api-registro.lawservices.com.br/api',
  tipoSaas: 1
};
export default environment;
